import {Component, OnInit} from '@angular/core';
import {StandardTypesService} from '../../../../../services/standard-types.service';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {Response} from '@angular/http';
import {AdminService} from '../../../../../services/admin.service';

@Component({
  selector: 'app-edit-standard-type',
  templateUrl: './edit-standard-type.component.html',
  styleUrls: ['./edit-standard-type.component.css']
})
export class EditStandardTypeComponent implements OnInit {
  newTypeRuName: string;
  newTypeEnName: string;
  successInfo = false;
  errorInfo = false;
  errorSix = false;
  errorTwelve = false;
  successEight = false;
  isLoaded = false;
  errMesg = false;
  typeMainGroup = null;

  constructor(public activeModal: NgbActiveModal,
              public standardTypeService: StandardTypesService,
              private adminService: AdminService) {
  }

  ngOnInit() {
    this.newTypeRuName = this.standardTypeService.getSelectedType().ruName;
    this.newTypeEnName = this.standardTypeService.getSelectedType().enName;
    // this.isLoaded = false;
    this.errMesg = false;

    // if (this.typeMainGroup !== null) {
    //   this.isLoaded = true;
    // }

  }

  setTypeMainGroup(mainGroup) {
    this.typeMainGroup = mainGroup;
    this.isLoaded = true;
  }

  onEditType() {
    this.errMesg = false;
    this.successInfo = false;
    this.errorInfo = false;
    this.errorSix = false;
    this.errorTwelve = false;
    this.successEight = false;


    if (this.newTypeRuName.trim().length > 3) {
      // Create new type object
      const newType = {
        id: this.standardTypeService.getSelectedType().id,
        ruName: this.newTypeRuName,
        enName: this.newTypeRuName,
        group: {
          id: this.typeMainGroup.id,
          name: this.typeMainGroup.name
        }
      };

      this.standardTypeService.editType(newType).subscribe(
        (response: any) => {
          if (response.status === 200) {
            this.successInfo = true;
            this.errorInfo = false;

            this.standardTypeService.getTypesList().forEach(type => {
              if (type.id === response.body.id) {
                type.ruName = response.body.ruName;
                type.enName = response.body.enName;
              }
            });
          }
        },
        () => {
          this.successInfo = false;
          this.errorInfo = true;
        }
      );
    } else {
      this.errorSix = true;
    }

  }

}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/admin/create-standard/modal/edit-standard-type/edit-standard-type.component.ts